//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import ItemId from '@models/ItemId';
import { UniversalItemType } from '@models/UniversalItemType';
import { isBulkSelected } from '@utils/networkItemUtils';

export const useGetIsBulkSelected = (
  itemType?: UniversalItemType,
  id?: ItemId,
) => {
  const selectedItems = useSelector((state) => state.bulkActions.selectedItems);
  return useMemo(() => {
    if (itemType && id) {
      return isBulkSelected(selectedItems, itemType, id);
    } else {
      return false;
    }
  }, [selectedItems, itemType, id]);
};

export const useGetIsAnyItemBulkSelected = () => {
  return useSelector((state) => state.bulkActions.selectedItems.length > 0);
};
